<template>
  <div id="app" v-if="appVisible">
    <v-app>
      <v-container class="logo pa-4">
        <v-row class="c-stamp-row">
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="5"
            lg="5"
            xl="4"
            class="c-stamp-column c-stamp-column--left"
          >
            <div id="preview">
              <h4 class="mt-4">Vista previa</h4>
              <div class="c-preview__container">
                <div class="c-preview__left">{{ height }} mm</div>
                <div class="c-preview__top">{{ width }} mm</div>
                <div
                  id="stamp"
                  ref="stamp"
                  :style="{
                    '--preview--width': `${width}`,
                    '--preview--height': `${height}`
                  }"
                >
                  <div class="stamp-wrapper">
                    <span v-if="text1.text" class="text" :style="styleText1">{{
                      text1.text
                    }}</span>
                    <span v-if="text2.text" class="text" :style="styleText2">{{
                      text2.text
                    }}</span>
                    <span v-if="text3.text" class="text" :style="styleText3">{{
                      text3.text
                    }}</span>
                    <span v-if="text4.text" class="text" :style="styleText4">{{
                      text4.text
                    }}</span>
                    <span v-if="text5.text" class="text" :style="styleText5">{{
                      text5.text
                    }}</span>
                    <span v-if="text6.text" class="text" :style="styleText6">{{
                      text6.text
                    }}</span>
                    <img
                      v-if="image"
                      :style="imageStyle"
                      :src="image"
                      alt="Vista previa del sello"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="7"
            lg="7"
            xl="8"
            class="logoContainer c-stamp-column c-stamp-column--right"
          >
            <v-col cols="12">
              <h4 class="mt-4 c-step">
                <span class="c-step__number">1</span>
                <span class="c-step__text">Añada su logotipo</span>
              </h4>
            </v-col>

            <v-container>
              <v-row>
                <v-col cols="5" md="4" xl="4">
                  <UploadImages
                    :max="1"
                    maxError="Solo se puede subir una imagen. Borre la anterior y suba una nueva"
                    fileError="Solo se aceptan imágenes"
                    @load="setImage"
                    @change="setImageData"
                    @delete="deleteImage"
                    uploadMsg="Sube tu logotipo"
                  />
                </v-col>
                <v-col v-if="image" cols="7" md="5" xl="5">
                  <div>
                    <v-subheader
                      ><v-icon>mdi-arrow-left</v-icon> Ajuste horizontal
                      <v-icon>mdi-arrow-right</v-icon></v-subheader
                    >
                    <input
                      class="c-range"
                      type="range"
                      min="0"
                      max="100"
                      step="1"
                      v-model="imgX"
                    />
                  </div>
                  <div>
                    <v-subheader
                      ><v-icon>mdi-arrow-up</v-icon>Ajuste vertical<v-icon
                        >mdi-arrow-down</v-icon
                      ></v-subheader
                    >
                    <input
                      class="c-range"
                      type="range"
                      min="0"
                      max="100"
                      step="1"
                      v-model="imgY"
                    />
                  </div>
                  <div>
                    <v-subheader>
                      <v-icon>mdi-arrow-expand-all</v-icon> Tamaño</v-subheader
                    >
                    <input
                      class="c-range"
                      type="range"
                      min="0.1"
                      max="1.2"
                      step="0.1"
                      v-model="imgWidthPercent"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>

            <v-container class="texts">
              <v-row class="mb-4">
                <v-col cols="12">
                  <h4 class="mt-4 c-step ml-0">
                    <span class="c-step__number">2</span>
                    <span class="c-step__text">Añada texto</span>
                  </h4>
                </v-col>
              </v-row>

              <div v-if="nlines >= 1">
                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L1</v-subheader>
                    <v-text-field
                      v-model="text1.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 1"
                      style="border: 0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L1</v-subheader>
                    <v-select
                      v-model="text1.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L1</v-subheader>
                    <v-select
                      v-model="text1.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L1</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text1.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon>mdi-format-bold</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text1.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text1.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text1.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L1
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          step="1"
                          v-model="text1.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <div v-if="nlines >= 2">
                <v-divider class="mt-6 mb-4"></v-divider>

                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L2</v-subheader>
                    <v-text-field
                      v-model="text2.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L2</v-subheader>
                    <v-select
                      v-model="text2.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L2</v-subheader>
                    <v-select
                      v-model="text2.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L2</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text2.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon>mdi-format-bold</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text2.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text2.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text2.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L2
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          max="100"
                          step="1"
                          v-model="text2.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <div v-if="nlines >= 3">
                <v-divider class="mt-6 mb-4"></v-divider>

                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L3</v-subheader>
                    <v-text-field
                      v-model="text3.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L3</v-subheader>
                    <v-select
                      v-model="text3.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L3</v-subheader>
                    <v-select
                      v-model="text3.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L3</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text3.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon icon="mdi-format-bold"
                            >mdi-format-bold</v-icon
                          >
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text3.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text3.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text3.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L3
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          max="100"
                          step="1"
                          v-model="text3.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <div v-if="nlines >= 4">
                <v-divider class="mt-6 mb-4"></v-divider>
                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L4</v-subheader>
                    <v-text-field
                      v-model="text4.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L4</v-subheader>
                    <v-select
                      v-model="text4.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      cols="6"
                      sm="3"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L4</v-subheader>
                    <v-select
                      v-model="text4.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L4</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text4.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon>mdi-format-bold</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text4.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text4.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text4.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L4
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          max="100"
                          step="1"
                          v-model="text4.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <div v-if="nlines >= 5">
                <v-divider class="mt-6 mb-4"></v-divider>

                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L5</v-subheader>
                    <v-text-field
                      v-model="text5.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 5"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L5</v-subheader>
                    <v-select
                      v-model="text5.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L5</v-subheader>
                    <v-select
                      v-model="text5.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L5</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text5.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon>mdi-format-bold</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text5.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text5.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text5.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L5
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          max="100"
                          step="1"
                          v-model="text5.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <div v-if="nlines >= 6">
                <v-divider class="mt-6 mb-4"></v-divider>

                <v-row class="mt-4 c-stamp-text__line">
                  <v-col cols="12" md="4" lg="2">
                    <v-subheader>Texto L6</v-subheader>
                    <v-text-field
                      v-model="text6.text"
                      dense
                      class="v-input"
                      placeholder="Texto para la línea 6"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tipografía L1</v-subheader>
                    <v-select
                      v-model="text6.font"
                      :items="textFamily"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="6" md="4" lg="2">
                    <v-subheader>Tamaño L1</v-subheader>
                    <v-select
                      v-model="text6.size"
                      :items="textSizes"
                      :item-value="value"
                      attach
                      auto
                      :item-text="text"
                      :return-object="false"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-subheader>Estilo L1</v-subheader>
                    <div class="font-style">
                      <v-btn-toggle v-model="text6.bold" color="default" dense>
                        <v-btn value="1" small>
                          <v-icon>mdi-format-bold</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text6.italic"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-italic</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text6.underline"
                        color="default"
                        dense
                      >
                        <v-btn value="1" small>
                          <v-icon>mdi-format-underline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="text6.align"
                        color="default"
                        dense
                        mandatory
                      >
                        <v-btn value="left" small>
                          <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn value="center" small>
                          <v-icon>mdi-format-align-center</v-icon>
                        </v-btn>
                        <v-btn value="right" small>
                          <v-icon>mdi-format-align-right</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="font-style">
                      <div>
                        <v-subheader class="pl-0 pr-0">
                          <span
                            style="text-align: center; display: block; width: 100%"
                          >
                            <v-icon>mdi-arrow-up</v-icon> Ajuste L6
                            <v-icon>mdi-arrow-down</v-icon>
                          </span>
                        </v-subheader>
                        <input
                          type="range"
                          min="-100"
                          max="100"
                          step="1"
                          v-model="text6.up"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-container>

            <v-container>
              <v-row class="mt-7">
                <v-col col="2" class="buttoncontainer">
                  <v-btn
                    small
                    text
                    color="default"
                    elevation="0"
                    v-if="nlines < 6"
                    v-on:click="addTextLine"
                    >+ Añadir línea</v-btn
                  >

                  <v-btn
                    small
                    class="ml-2"
                    text
                    color="default"
                    v-if="nlines > 1"
                    v-on:click="deleteTextLine"
                    >- Eliminar línea</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>

            <v-container class="pt-10 pb-4">
              <v-row class="mt-4 mb-4">
                <v-divider></v-divider>
              </v-row>

              <v-row class="mb-4">
                <v-col cols="12">
                  <h4 class="mt-4 mb-4 c-step">
                    <span class="c-step__number">3</span>
                    <span class="c-step__text">Finalice el proceso</span>
                  </h4>
                </v-col>
                <v-col class="buttoncontainer">
                  <v-btn small text color="default" v-on:click="makePhoto"
                    >Descarga tu sello</v-btn
                  >
                  <v-btn small text color="default" v-on:click="finishDesign"
                    >Finalizar diseño</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>

            <v-container class="">
              <v-row>
                <v-col cols="12">
                  <section class="buttonsContainer">
                    <!-- <button v-on:click="makePhoto">Descargar</button> -->
                    <button small style="display: none" id="download">
                      Descarga tu sello
                    </button>
                  </section>
                  <div>
                    <EllipsisLoader :color="'#de005b'" v-if="loading" />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
// import { EllipsisLoader } from "vue-spinners-css";
// import ImageUploader from "vue-image-upload-resize";
import UploadImages from "./components/vue-upload-drop-images.vue";
import "core-js/stable";
import "regenerator-runtime/runtime";

export default {
  name: "ModicoStampMaker",
  components: {
    // EllipsisLoader,
    // ImageUploader,
    UploadImages
  },
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    circle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      appVisible: true,
      hasImage: false,
      image: null,
      loading: false,
      pdf: false,
      imgWidthPercent: 0.5,
      imgX: 50,
      imgY: 50,
      nlines: 1,
      text1: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      text2: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      text3: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      text4: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      text5: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      text6: {
        text: "",
        size: 20,
        font: "Arial",
        up: 0,
        align: "left",
        bold: "0",
        italic: "0",
        underline: "0"
      },
      textFamily: [
        {
          value: "Arial",
          text: "Arial"
        },
        {
          value: "Dela Gothic One",
          text: "Dela Gothic One"
        },
        {
          value: "Helvetica",
          text: "Helvetica"
        },
        {
          value: "Courier",
          text: "Courier"
        },
        {
          value: "Dancing Script",
          text: "Dancing Script"
        },
        {
          value: "Quicksand",
          text: "Quicksand"
        },
        {
          value: "Roboto",
          text: "Roboto"
        },
        {
          value: "Roboto Mono",
          text: "Roboto Mono"
        },
        {
          value: "Oswald",
          text: "Oswald"
        }
      ],
      textStyle: [
        {
          value: "normal",
          text: "Normal"
        },
        {
          value: "italic",
          text: "Cursiva"
        },
        {
          value: "underline",
          text: "Subrayado"
        }
      ],
      textAlign: [
        {
          value: "left",
          text: "Izqierda"
        },
        {
          value: "center",
          text: "Centrado"
        },
        {
          value: "right",
          text: "Derecha"
        }
      ],
      output: null
    };
  },
  init: function() {},
  mounted: function() {
    this.updateSize();

    window.$(window).resize(() => {
      this.updateSize();
    });
  },
  methods: {
    setImage: function(img) {
      this.hasImage = true;
      this.image = img;
    },
    getExtensionFromBase64: function(base64String) {
      // Verificar que la cadena no sea nula o vacía
      if (!base64String) {
        throw new Error("Base64 string is null or empty");
      }

      // Buscar el encabezado y extraer el tipo MIME
      const mimeTypeMatch = base64String.match(/^data:(image\/[a-zA-Z0-9+.-]+);base64,/);

      if (!mimeTypeMatch) {
        throw new Error("Invalid base64 image string");
      }

      const mimeType = mimeTypeMatch[1];

      // Crear un mapa de tipos MIME a extensiones
      const mimeTypeToExtensionMap = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/bmp': 'bmp',
        'image/webp': 'webp',
        'image/svg+xml': 'svg'
      };

      // Obtener la extensión correspondiente
      const extension = mimeTypeToExtensionMap[mimeType];

      if (!extension) {
        throw new Error("Unsupported MIME type: " + mimeType);
      }

      return extension;
    },
    updateSize: function() {
      document
        .querySelector(".c-stamp-row")
        .style.setProperty("--stamp-width", this.dataConfigStamp.width);

      document
        .querySelector(".c-stamp-row")
        .style.setProperty("--stamp-height", this.dataConfigStamp.height);

      let padding = 24;
      let widthStamp = 350;
      let wStamp = 0;

      if (window.$(window).width() < 500) {
        widthStamp = window.$(window).width() - 2 * padding - 16 - 40;
      }

      /* Tamaño del sello */
      // window.$("#stamp").css("max-width", `${widthStamp}px`);
      // wStamp = window.$("#stamp").width();

      // window
      //   .$("#stamp")
      //   .css(
      //     "height",
      //     `${Math.round(wStamp / this.dataConfigStamp.proportion)}px`
      //   );
      /* END: Tamaño del sello */

      if (this.dataConfigStamp.circle) {
        this.text1.align = "center";
        this.text2.align = "center";
        this.text3.align = "center";
        this.text4.align = "center";
        this.text5.align = "center";
        this.text6.align = "center";

        // window.$("#stamp").css("max-width", `${widthStamp}px`);
        wStamp = window.$("#stamp").width();

        window.$("#stamp").css("border-radius", "50%");
        window.$("#stamp").css("overflow", "hidden");
      }
      // window
      //   .$(".c-preview__container")
      //   .width(window.$("#stamp").width() + 24)
      //   .css("height", window.$("#stamp").height() + 48);

      // window
      //   .$(".c-preview__container")
      //   .css("max-width", `${window.$("#stamp").width() + 48}px`);

      console.log("Resize");
    },

    setImageData: function() {},

    deleteImage: function() {
      this.hasImage = false;
      this.image = false;
    },

    addTextLine: function() {
      if (this.nlines < 6) {
        this.nlines++;
      }
    },

    deleteTextLine: function() {
      switch (this.nlines) {
        case 6:
          this.text6.text = "";
          break;
        case 5:
          this.text5.text = "";
          break;
        case 4:
          this.text4.text = "";
          break;
        case 3:
          this.text3.text = "";
          break;
        case 2:
          this.text2.text = "";
          break;
      }
      if (this.nlines > 0) {
        this.nlines--;
      }
    },

    makePhoto: function() {
      const el = this.$refs.stamp;
      const options = {
        type: "dataURL",
        capture: "false",
        backgroundColor: "rgba(0,0,0,0)",
        allowTaint: true,
        // debug: 2,
        scale: 4
      };
      this.$html2canvas(el, options).then(canvas => {
        //self.output = canvas;
        var currentDate = new Date();
        // get current date YYYYMMDD-HHMMII
        var date =
          currentDate.getFullYear() +
          "-" +
          (currentDate.getMonth() + 1).toString().padStart(2, 0) +
          "-" +
          currentDate
            .getDate()
            .toString()
            .padStart(2, 0) +
          "-" +
          currentDate
            .getHours()
            .toString()
            .padStart(2, 0) +
          "-" +
          currentDate
            .getMinutes()
            .toString()
            .padStart(2, 0) +
          "-" +
          currentDate
            .getSeconds()
            .toString()
            .padStart(2, 0);

        var a = document.createElement("a");
        a.href = canvas;
        a.download = "stamp-" + date + ".png";
        a.click();
      });
    },

    finishDesign: function() {
      const el = this.$refs.stamp;
      const options = {
        type: "dataURL",
        capture: "false",
        backgroundColor: "rgba(0,0,0,0)",
        allowTaint: true,
        scale: 4
      };

      // Detect what type of product is
      //
      let classSingleProduct = ".single_add_to_cart_button";
      let classVariableProduct = ".woocommerce-variation-add-to-cart";
      let classGlobal = ".woocommerce-variation-add-to-cart, .product-type-simple form.cart";

      let productFormSelector = classGlobal;

      this.$html2canvas(el, options).then(canvas => {
        //self.output = canvas;

        // if exists input[name=stamp-image] remove it
        window.$("input[name=stamp-image]").remove();

        // Append canvas to form
        window
          .$(productFormSelector)
          .append(
            `<input name="stamp-image" type="hidden" value="${canvas}"></input>`
          );

        // if exists input[name=stamp-image-user] remove it
        window.$("input[name=stamp-image-user]").remove();

        // Append image to form (if exists)
        if (this.hasImage) {
          window
            .$(productFormSelector)
            .append(
              `<input name="stamp-image-user" type="hidden" value="${this.image}"></input>`
            );

            let file_extension = this.getExtensionFromBase64(this.image);
          // add file extension to field
          window
            .$(productFormSelector)
            .append(
              `<input name="stamp-image-user-ext" type="hidden" value="${file_extension}"></input>`
            );
        }

        // if exists js-stamp-preview remove it
        window.$(".js-stamp-preview").remove();

        // Apend canvas to show in product
        window
          .$(
            `<div class="js-stamp-preview"><img style="width: 100%; max-width: 200px; border: 1px solid #ccc;" src="${canvas}"></img></div>`
          )
          .insertBefore(`${productFormSelector} .quantity`);
      });

      // this.appVisible = false;
      window
        .$("button[type=submit]")
        .prop("disabled", false)
        .text("Añadir al carrito");
      window.$(productFormSelector).show();

      window.$(".js-custom-first").css("display", "none");

      let target = window.$(".c-single-product__info");
      window.$("html, body").animate(
        {
          scrollTop: window.$(target).offset().top - 75
        },
        250
      );
    }
  },
  watch: {},
  computed: {
    styleText1: function() {
      let bold = "normal";
      if (this.text1.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text1.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text1.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text1.font}';
        line-height: 1.2em;
        font-size: ${this.text1.size}pt;
        text-align: ${this.text1.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text1.up}%;
        z-index: 5;
      `;
    },
    styleText2: function() {
      let bold = "normal";
      if (this.text2.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text2.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text2.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text2.font}';
        line-height: 1.2em;
        font-size: ${this.text2.size}pt;
        text-align: ${this.text2.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text2.up}%;
        z-index: 5;
      `;
    },
    styleText3: function() {
      let bold = "normal";
      if (this.text3.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text3.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text3.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text3.font}';
        line-height: 1.2em;
        font-size: ${this.text3.size}pt;
        text-align: ${this.text3.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text3.up}%;
        z-index: 5;
      `;
    },
    styleText4: function() {
      let bold = "normal";
      if (this.text4.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text4.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text4.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text4.font}';
        line-height: 1.2em;
        font-size: ${this.text4.size}pt;
        text-align: ${this.text4.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text4.up}%;
        z-index: 5;
      `;
    },
    styleText5: function() {
      let bold = "normal";
      if (this.text5.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text5.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text5.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text5.font}';
        line-height: 1.2em;
        font-size: ${this.text5.size}pt;
        text-align: ${this.text5.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text5.up}%;
        z-index: 5;
      `;
    },
    styleText6: function() {
      let bold = "normal";
      if (this.text6.bold == "1") {
        bold = "bold";
      }

      let italic = "normal";
      if (this.text6.italic == "1") {
        italic = "italic";
      }

      let underline = "none";
      if (this.text6.underline == "1") {
        underline = "underline";
      }

      return `
        font-weight: ${bold};
        text-decoration: ${underline};
        display: block;
        font-style: ${italic};
        font-family: '${this.text6.font}';
        line-height: 1.2em;
        font-size: ${this.text6.size}pt;
        text-align: ${this.text6.align};
        font-style="${italic}";
        position: relative;
        top: ${this.text6.up}%;
        z-index: 5;
      `;
    },
    imageWidth: function() {
      return 400 * this.imgWidthPercent;
    },
    imageStyle: function() {
      // return `height: auto; position: absolute; transform: translate(-50%, -50%); width: ${this.imageWidth}px; top: ${this.imgY}%; left: ${this.imgX}%;`;
      return `z-index:1;height: auto; position: absolute; width: ${
        this.imageWidth
      }px; top: ${this.imgY / 2}%; left: ${this.imgX}%; margin-left: -${this
        .imageWidth / 2}px;`;
    },
    textSizes: function() {
      let sizes = Array();
      for (let index = 0; index < 40; index++) {
        sizes[index] = {
          text: (index + 10).toString(),
          value: index + 15
        };
      }
      return sizes;
    },
    dataConfigStamp: function() {
      return {
        width: parseFloat(this.width),
        height: parseFloat(this.height),
        circle: parseInt(this.circle) == 1 ? true : false,
        proportion: parseFloat(this.width) / parseFloat(this.height)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #00546e;
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif; /* this was it */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $primary;

  .v-application--wrap {
    padding: 10px !important;
    min-height: none !important;
  }

  h4 {
    font-size: 18px;
    line-height: 18px;
  }

  .settingsContainer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 10px;
  }

  .buttonsContainer {
    margin-bottom: 10px;
  }

  .previewContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
  }

  #stamp{
    padding: 0.5rem;
    background-color: white;
  }

  #stamp .stamp-wrapper {
    overflow: hidden;
    background-color: white;
    position: relative;
    width: 100%;

    aspect-ratio: var(--preview--width, 1) / var(--preview--height, 1);
  }

  @supports not (aspect-ratio: var(--preview--width, 1) / var(--preview--height, 1)) {
    #stamp {
      position: relative;
    }

    #stamp:before {
      display: block;
      content: "";
      width: 100%;
      padding-top: calc(
        (var(--preview--height, 1) / var(--preview--width, 1)) * 100%
      );
    }
    #stamp > .stamp-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  #fileInput {
    display: none;
  }

  .output {
    width: 100%;
  }

  .v-subheader {
    padding-left: 0 !important;
    padding-right: 0;
    height: 25px !important;
    margin-top: 20px;
  }

  .logoContainer {
    .v-subheader {
      margin-top: 0;
    }
  }

  .container {
    padding-top: 0;
    padding-bottom: 0;
    .col {
      padding: 3px 8px;
    }
    .col-sm-3,
    .col-sm-2,
    .col-12 {
      // padding: 3px 8px !important;
    }
    input[type="range"] {
      position: relative;
      top: 5px;
    }

    .row + .row {
      margin-top: 5px;
    }
  }

  .font-style {
    display: flex;
    align-items: flex-end;
    padding-top: 5px;
    justify-content: flex-start;
    gap: 16px;

    @media (max-width: 800px) {
      flex-wrap: wrap;
    }
  }

  .c-step {
    display: flex;
    align-items: center;
    &__number {
      background-color: #b6c926;
      padding: 5px;
      border-radius: 50%;
      color: white;
      width: 22px;
      height: 22px;
      display: flex;
      justify-content: center;
      align-content: center;
      font-size: 14px;
      line-height: 14px;
      margin-right: 10px;
    }
    &__text {
    }
  }

  .buttoncontainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px 5px;

    button {
      color: white;
      background-color: $primary;
    }
  }

  .c-preview {
    &__container {
      position: relative;
      padding: 24px;
      background-color: rgba(16, 25, 28, 0.08);
      margin-bottom: 20px;
      // display: inline-block;
    }

    &__top {
      position: absolute;
      top: 4px;
      left: 24px;
      width: calc(100% - 48px);
      text-align: center;
      font-size: 12px;
      &:after {
        position: absolute;
        left: 0;
        width: 43%;
        border-bottom: 1px solid black;
        height: 1px;
        content: "";
        top: 8px;
      }
      &:before {
        position: absolute;
        right: 0;
        width: 43%;
        border-bottom: 1px solid black;
        height: 1px;
        content: "";
        top: 8px;
      }
    }
    &__left {
      position: absolute;
      top: 0px;
      left: 0px;
      writing-mode: vertical-rl;
      text-align: center;
      font-size: 12px;
      width: 24px;
      height: 100%;
      transform: rotate(180deg);
      &:after {
        position: absolute;
        left: 0;
        right: 12px;
        bottom: 24px;
        width: 1px;
        border-left: 1px solid #00546e;
        height: calc(50% - 60px);
        content: "";
      }
      &:before {
        position: absolute;
        left: 0;
        right: 12px;
        top: 24px;
        width: 1px;
        border-left: 1px solid #00546e;
        height: calc(50% - 60px);
        content: "";
      }
    }
  }

  @media (min-width: 960px) {
    .container {
      max-width: 100% !important;
    }
  }
  input[type="text"] {
    border: 0;
    background-color: red;
  }

  .c-stamp-row {
    @media (max-width: 599.99px) {
      position: relative;

      .c-stamp-column {
        &--left {
          // padding-top: calc( calc(calc(var(--stamp-height, 1) / var(--stamp-width, 1)) * 100%) + 10% ) !important;

          background-color: white;

          position: sticky;
          top: 0;
          width: 100%;
          z-index: 100;
        }
      }
    }
  }

  .c-stamp-column {
    &--left {
      @media (min-width: 600px) {
        position: relative;

        > * {
          position: sticky;
          top: 0;
        }
      }
    }
    &--right {
    }
  }

  .c-stamp-text__line {
    > .col,
    > [class*="col-"] {
      padding: 3px 8px !important;
    }
  }

  .c-range {
    width: 100%;
  }
}
</style>
